import React from 'react';
import { CTAButton } from './CTAButton';
import { StarIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_IMG, PRODUCT_NAME } from './constants';
export function Hero() {
  return <section className="pt-6 pb-8 px-4 bg-white" data-id="element-96" data-mp="9ka68zwg6uxg">
      <div className="max-w-3xl mx-auto text-center" data-id="element-97" data-mp="9l37jlcn0s87">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-gold/15 border border-brand-gold/40 text-brand-navy font-bold text-xs sm:text-sm mb-3" data-id="element-98" data-mp="4mi3tby6fqf0">
          <span data-id="element-99" data-mp="xanoxzt57hfd">🤸</span>
          <span data-id="element-100" data-mp="xa4ef45tnvbd">COMPLETE 6-IN-1 VISUAL GYMNASTICS COACHING SYSTEM</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-extrabold text-brand-ink leading-tight mb-3" data-id="element-101" data-mp="sartwq2fb0by">
          Plan Faster. Coach Better. Stop Starting From Scratch.
        </h1>

        <p className="text-base sm:text-lg text-brand-slate font-medium leading-snug mb-4 max-w-2xl mx-auto" data-id="element-102" data-mp="3d21t5zvq8oos">
          Get ready-to-use practice plans, visual skill progressions, planning
          tools, assessments, and coaching resources—all organized in one
          professional system.
        </p>

        <div className="inline-block bg-brand-navy text-white px-4 py-1.5 rounded-lg mb-4 shadow-md" data-id="element-103" data-mp="3o7vjnj38jlwr">
          <p className="font-bold text-sm sm:text-base tracking-wide font-display" data-id="element-104" data-mp="39b4gqzucrs2e">
            🤸 {PRODUCT_NAME} — Complete 6-in-1 System
          </p>
        </div>

        <div className="mb-5" data-id="element-105" data-mp="30i1abbi4kfh9">
          <a href="#pricing" className="block cursor-pointer" data-id="element-106" data-mp="30hrjxmt646b1">
            <img src={PRODUCT_IMG} alt="Gymnastics Coach Pro 6-in-1 Complete Planning System box set" className="w-full h-auto object-contain max-w-md sm:max-w-lg mx-auto hover:scale-[1.02] transition-transform duration-300 drop-shadow-2xl" data-id="element-107" data-mp="358rbsdnfjy6o" />
          </a>
        </div>

        <div className="mb-3" data-id="element-108" data-mp="2hincujl6smm0">
          <CTAButton className="max-w-md mx-auto" data-id="element-109" data-mp="2hjoyfhztwrhz">
            🚀 YES! I WANT MY SYSTEM NOW
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-5 gap-y-1 text-sm text-brand-ink font-bold" data-id="element-110" data-mp="2lml9mnn1hlbw">
          <div className="flex items-center gap-1.5" data-id="element-111" data-mp="nbl4gqm0mqd3">
            <StarIcon className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-112" data-mp="n9qkbeikj2a2" />
            <span data-id="element-113" data-mp="id9v0gzmuhve">4.9/5 — Verified Coach Reviews</span>
          </div>
          <span className="hidden sm:inline text-brand-line" data-id="element-114" data-mp="ddf5agrlfybx">•</span>
          <div className="flex items-center gap-1.5" data-id="element-115" data-mp="db2dlbw1a9lo">
            <ShieldCheckIcon className="w-4 h-4 text-brand-blue" data-id="element-116" data-mp="1azul7e4dgnxd" />
            <span data-id="element-117" data-mp="161szsmjh4ciq">7-Day Money-Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}